import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className="btmbdrgry"><h3>{children}</h3></div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const [open, setOpen] = React.useState(false); 
 
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

   
  return (
    <>
      <Dialog fullScreen style={{margin:20}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{props.dataObj.patternTitle}</DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} >
                  <p>
                      <table style={{minWidth:1200 }} cellPadding="3" >
                        <tbody style={{scrollX:'Auto'}}>
                        <tr>
                            <td className='btmbdrgrydotted' >Pattern Title</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.patternTitle}</td>
                            <td className='btmbdrgrydotted' >Description</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.patternDescription}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >Total time for Test(min)</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.totalTime}</td>
                            <td className='btmbdrgrydotted' >Total Questions</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.totalQuestion}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >Section Allow</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.sectionAllow?<>YES</>:<>NO</>}</td>                            
                            <td className='btmbdrgrydotted' ></td>
                            <td className='btmbdrgrydotted' ></td>                            
                        </tr>
                        {!props.dataObj.sectionAllow?<>
                        <tr>
                            <td className='btmbdrgrydotted' >Marks Correct Ans</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.marksCorrectAns}</td>
                            <td className='btmbdrgrydotted' >Marks Incorrect Ans</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.marksIncorrectAns}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >Marks Not Ans</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.marksNotAns}</td>
                            <td className='btmbdrgrydotted' >Max Question Attempt</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.maxQuestionAttempt}</td>                            
                        </tr>
                        </>:null}
                        <tr>
                            <td className='btmbdrgrydotted' >Last Year Min</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.lastYearMin}</td>
                            <td className='btmbdrgrydotted' >Last Year Max</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.lastYearMax}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >SME Benchmark Min</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.smeBenchmarkMin}</td>
                            <td className='btmbdrgrydotted' >SME Benchmark Max</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.smeBenchmarkMax}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >Approx Benchmark Min</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.approxBenchmarkMin}</td>
                            <td className='btmbdrgrydotted' >Approx Benchmark Max</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.approxBenchmarkMax}</td>                            
                        </tr>
                        <tr>
                            <td className='btmbdrgrydotted' >Treeview</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.treeviewTemplateTitle}</td>
                            <td className='btmbdrgrydotted' >Exam Type</td>
                            <td className='btmbdrgrydotted' >{props.dataObj.examType}</td>                            
                        </tr>
                        </tbody>
                      </table>

                  </p>
            </Grid>





       </DialogContent>
      </Dialog>
      
                

    </>
  );

});

export default CustomizedDialogs;